var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCreateAiLinear = function SvgIconCreateAiLinear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-create-ai-linear_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-create-ai-linear_svg__b)",
    d: "M.168 15.524a.572.572 0 0 0 .808.808l1.696-1.696-.808-.808z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-create-ai-linear_svg__c)",
    d: "m13.208 6.982-.75-1.006.403-1.188a.907.907 0 0 0-1.15-1.15l-1.188.403-1.006-.75a.907.907 0 0 0-1.45.739l.017 1.254-1.024.724a.907.907 0 0 0 .254 1.607l.582.18-5.37 5.37.808.808 5.37-5.37c.19.611.206.745.388.938a.908.908 0 0 0 1.399-.102l.724-1.024 1.267.016a.907.907 0 0 0 .726-1.45"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-create-ai-linear_svg__d)",
    d: "M14.11 9.145a.469.469 0 1 0-.663.663l.498.498a.469.469 0 1 0 .663-.663z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-create-ai-linear_svg__e)",
    d: "M15.532 6.54h-.704a.469.469 0 1 0 0 .936h.704a.469.469 0 1 0 0-.937"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-create-ai-linear_svg__f)",
    d: "M11.311 10.055a.47.47 0 0 0-.469.468v.704a.469.469 0 1 0 .938 0v-.704a.47.47 0 0 0-.469-.468"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-create-ai-linear_svg__g)",
    d: "M6.693 3.056a.469.469 0 1 0 .663-.663l-.498-.498a.469.469 0 1 0-.663.663z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-create-ai-linear_svg__h)",
    d: "M9.492 2.141c.259 0 .469-.21.469-.468V.969a.469.469 0 0 0-.938 0v.704c0 .258.21.468.47.468"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-create-ai-linear_svg__i)",
    d: "M5.272 5.656h.704a.469.469 0 0 0 0-.937h-.704a.469.469 0 0 0 0 .937"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-create-ai-linear_svg__b",
    x1: 0,
    x2: 2.672,
    y1: 15.164,
    y2: 15.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-create-ai-linear_svg__c",
    x1: 2.526,
    x2: 13.39,
    y1: 8.541,
    y2: 8.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-create-ai-linear_svg__d",
    x1: 13.31,
    x2: 14.745,
    y1: 9.725,
    y2: 9.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-create-ai-linear_svg__e",
    x1: 14.359,
    x2: 16,
    y1: 7.008,
    y2: 7.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-create-ai-linear_svg__f",
    x1: 10.842,
    x2: 11.78,
    y1: 10.875,
    y2: 10.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-create-ai-linear_svg__g",
    x1: 6.058,
    x2: 7.493,
    y1: 2.475,
    y2: 2.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-create-ai-linear_svg__h",
    x1: 9.023,
    x2: 9.961,
    y1: 1.321,
    y2: 1.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-create-ai-linear_svg__i",
    x1: 4.803,
    x2: 6.445,
    y1: 5.187,
    y2: 5.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-create-ai-linear_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h16v16H0z"
  })))));
};
export default SvgIconCreateAiLinear;